import { useNavigate } from "react-router";

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-[80vh] flex flex-col items-center justify-center text-center px-4 bg-slate-50">
      <div className="bg-white rounded-3xl shadow-card px-10 py-14 max-w-sm w-full">
        <p className="font-display text-7xl font-bold text-primary-100 mb-2">404</p>
        <h2 className="font-display text-2xl font-semibold text-slate-900 mb-2">Page not found</h2>
        <p className="font-body text-slate-500 text-sm mb-8 leading-relaxed">
          We couldn't find the page you're looking for. Try browsing our course catalogue or use the links below.
        </p>
        <div className="flex flex-col gap-3">
          <button
            onClick={() => navigate("/")}
            className="w-full h-11 rounded-xl bg-primary-900 text-white font-body font-semibold text-sm hover:bg-primary-800 transition-colors"
          >
            Browse courses
          </button>
          <button
            onClick={() => navigate(-1)}
            className="w-full h-11 rounded-xl border-2 border-slate-200 text-slate-700 font-body font-semibold text-sm hover:border-primary-400 hover:text-primary-900 transition-all"
          >
            Go back
          </button>
        </div>
      </div>
    </div>
  );
};
export default NotFound;
